module.exports = __webpack_public_path__ + "img/wheel_buyfeature_normal_mg.862b18a8.png";